import React from 'react';
import '../../styles/components/AsperaWrapper.scss';
import { Loading } from '../Carbon';
import { language } from '../../services/LanguageService';
import { fullPageModeClass } from '../../constants/constants';
import { AsperaPageHeader } from '../AsperaPageHeader';
import { AsperaErrorState } from '../AsperaErrorState';
/**
 * React Component
 *
 * The AsperaWrapper provides a simple way to include errors and loading around your component.
 *
 * You should not use loading if using tabs with header.  The final child should have loading screen. Otherwise double loader may be possible.
 *
 * @example
 * ```javascript
 * <AsperaWrapper loading={false} error={false}>
 *   <h1>Inner child that shows when loading and error are false</h1>
 * </AsperaWrapper>
 * ```
 */
export class AsperaWrapper extends React.Component {
    constructor() {
        super(...arguments);
        /** Default Error props text (generic error message) */
        this.defaultErrorProps = {
            title: language.get('errors.genericError'),
            body: language.get('errors.genericErrorDescription'),
        };
        this.everHadFullScreen = false;
    }
    getView() {
        const { loading, error, errorProps, children, smallRender, customLoadingComponent } = this.props;
        if (loading) {
            return customLoadingComponent ? customLoadingComponent : React.createElement(Loading, { description: language.get('pageSystem.loading'), withOverlay: false, className: "center-loading", "data-auto": "aspera-wrapper-loading" });
        }
        else if (error) {
            return React.createElement(AsperaErrorState, Object.assign({}, (errorProps || this.defaultErrorProps), { "data-auto": "aspera-wrapper-error", smallRender: smallRender }));
        }
        else {
            return children;
        }
    }
    /**
     * Decide if full screen styling should be used via CSS
     *
     * @param remove - indicate if the style should be removed from body
     */
    handleFullScreenStyling(remove) {
        const { fullScreenMode } = this.props;
        const body = document.querySelector('body');
        if (remove && this.everHadFullScreen) {
            body.classList.remove(fullPageModeClass);
            return;
        }
        if (fullScreenMode) {
            body.classList.add(fullPageModeClass);
            this.everHadFullScreen = true;
        }
    }
    componentDidMount() {
        this.handleFullScreenStyling();
    }
    componentWillUnmount() {
        this.handleFullScreenStyling(true);
    }
    componentDidUpdate(previousProps) {
        const { fullScreenMode } = this.props;
        if (fullScreenMode !== previousProps.fullScreenMode) {
            this.handleFullScreenStyling(true);
            setTimeout(() => {
                this.handleFullScreenStyling();
            });
        }
    }
    render() {
        const { className, pageHeaderProps, id, loading, error, disableWrapping } = this.props;
        return (React.createElement("div", { className: `aspera-wrapper ${className ? className : ''}`, id: id },
            !!pageHeaderProps && React.createElement(AsperaPageHeader, Object.assign({ viewNotReady: loading || error }, pageHeaderProps)),
            React.createElement("div", { className: "aspera-wrapper-primary-view" },
                React.createElement("div", { className: disableWrapping ? 'standard-page-no-wrapping' : 'standard-page-wrapping cds--grid' }, this.getView()))));
    }
}
